import { Pricing } from "../../pricing_list/pricingListSlice";

export function getProxyNameByPricing(pricing: Pricing) {
	if (pricing.portfolio) {
        return pricing?.tourbillon_ref || "CLUSTER"
	}

	return (
		pricing?.tourbillon_ref ||
		pricing?.site_pricings?.[0].site.cluster_names
	);
}
